// extracted by mini-css-extract-plugin
export var bodySections = "_e2-8";
export var gray = "_e2-7";
export var green = "_e2-4";
export var iconContainer = "_e2-9";
export var iconWidgetContainer = "_e2-1";
export var phoneIcon = "_e2-2";
export var red = "_e2-5";
export var statusDot = "_e2-3";
export var widgetContainer = "_e2-0";
export var yellow = "_e2-6";